app.service('compareConfig', function(pageConfig) {
	function getData(){
		return pageConfig.getData('compare');
	}
	
	return {
		getData: getData
	};
});